import axios from "axios";
import { API } from "@/App";

export const addonCheckout = async (addonType, { t, onAttached, qty = 1 } = {}) => {
  const q = (await axios.get(`${API}/billing/addon/quote`, { params: { addon_type: addonType, qty } })).data;
  const monthly = `€${Number(q.monthly).toFixed(2)}/${t("addons.mo")}`;
  const msg = q.mode === "attach"
    ? t("addons.confirmAttach", { now: Number(q.amount_now).toFixed(2), monthly })
    : t("addons.confirmCheckout", { monthly });
  if (!window.confirm(msg)) return { cancelled: true };
  const r = await axios.post(`${API}/billing/addon/checkout`, { addon_type: addonType, qty, origin_url: window.location.origin });
  if (r.data?.status === "attached") {
    onAttached?.(r.data);
    return r.data;
  }
  if (r.data?.url) window.location.href = r.data.url;
  return r.data;
};
